import React, { useEffect, useState } from "react";
import api from "../../../api/axiosInstance";
import Icon from "../../../components/AppIcon";
import { useNavigate } from "react-router-dom";
const BootcampRegistrations = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  useEffect(() => {

    const loadUsers = async () => {

      const res = await api.get("/api/bootcamp/bootcamp-users");

      setUsers(res.data);

    };

    loadUsers();

  }, []);

  return (

    <div className="p-6">
<div className="flex items-center gap-3 mb-4">

<button
onClick={() => navigate("/admin/bootcamp")}
className="flex items-center gap-2 text-muted-foreground hover:text-primary"
>
<Icon name="ArrowLeft" size={18}/>
Back
</button>

</div>
      <h2 className="text-2xl font-bold mb-6">
        Bootcamp Registrations
      </h2>

      <table className="w-full border">

        <thead>
          <tr className="border">
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
          </tr>
        </thead>

        <tbody>

          {users.map((u) => (

            <tr key={u._id} className="border">

              <td>{u.name}</td>
              <td>{u.email}</td>
              <td>{u.phone}</td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  );
};

export default BootcampRegistrations;